import { render, staticRenderFns } from "./SamplesTip.vue?vue&type=template&id=7ec26732&"
import script from "./SamplesTip.vue?vue&type=script&lang=js&"
export * from "./SamplesTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports